import {
  Add_Developers,
  Delete_Developers,
  Get_Developers,
  Get_Error,
  Get_One_Developer,
  Update_Developers,
} from '../Types';

const intial = {
  Developers: [],

  loading: true,
};

const Developer_Reducer = (state = intial, action) => {
  switch (action.type) {
    case Add_Developers:
      return {
        Developers: action.payload,
        loading: false,
      };
    case Get_Developers:
      return {
        ...state,
        Developers: action.payload,
        loading: false,
      };
    case Update_Developers:
      return {
        ...state,
        Developers: action.payload,
        loading: false,
      };
    case Delete_Developers:
      return {
        ...state,
        Developers: action.payload,
        loading: false,
      };
    case Get_One_Developer:
      return {
        ...state,
        Developers: action.payload,
        loading: false,
      };

    case Get_Error:
      return {
        loading: true,
        Developers: action.payload,
      };
    default:
      return state;
  }
};

export default Developer_Reducer;
